import React from 'react';
import Sponsorship from '../components/Sponsorship';
import Outreach from '../components/Outreach';
import Join from '../components/Join';

export default function Support() {
  return (
    <>
      <Sponsorship />
      <Outreach />
      <Join />
    </>
  );
}
